import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { firstAllowedPath } from "@/components/Layout";

export default function ProtectedRoute({ children, perm, anyPerm }) {
  const { user, loading, can } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-pulse text-muted-foreground font-display">Loading MobiMed…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if ((perm && !can(perm)) || (anyPerm && !anyPerm.some((p) => can(p)))) {
    // Send users to the first screen they are allowed to open; message only if they have none.
    const home = firstAllowedPath(can);
    if (home && home !== location.pathname) return <Navigate to={home} replace />;
    return (
      <div className="p-10 text-center">
        <h2 className="text-xl font-semibold text-foreground">Access restricted</h2>
        <p className="text-muted-foreground mt-2">You don't have permission to view this page.</p>
      </div>
    );
  }
  return children;
}
